import { TYPE_OF_REPORT } from 'service/actionType.js'
  export const setReportPage = (data) => {
    return {
      type: TYPE_OF_REPORT,
      payload: data,
    };
  };
